import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MaterialeOrdine } from '../../_models/MaterialeOrdine';
import { OrdineVendita } from '../../_models/OrdineVendita';
import { Articolo } from '../../_models/Articolo';
import { VenditaService } from '../../_services/vendita.service';
import { SaveMessage } from '../../_helpers/save-message';

const emptyMateriale = (ordine: OrdineVendita): MaterialeOrdine => ({
  organizzazioneId: ordine.organizzazioneId,
  idOrdineVendita:  ordine.idOrdineVendita,
  idRigaPadre:      ordine.idRiga,
  idRigaMateriale:  0,
  numFase:          1,
  codArt:           '',
  desArticolo:      '',
  unitaMisura:      '',
  quantita:         1
});

@Component({
  selector: 'app-materiale-ordine-create',
  templateUrl: './materiale-ordine-create.component.html',
  standalone: false
})
export class MaterialeOrdineCreateComponent implements OnInit {
  @Input() materiale: MaterialeOrdine;
  @Input() ordine: OrdineVendita;
  @Input() isNew = true;

  loading = false;

  /** Id usato da app-select-articolo-prodotto per precaricare l'articolo in modifica */
  articoloId = 0;

  constructor(
    private venditaService: VenditaService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage
  ) {}

  ngOnInit() {
    if (!this.materiale) {
      this.materiale = emptyMateriale(this.ordine);
    }
  }

  /** Chiamato da app-select-articolo-prodotto quando l'utente sceglie un articolo.
   *  Popola automaticamente codArt, variante, desArticolo, unitaMisura, umSecondaria. */
  onArticoloSelezionato(articolo: Articolo) {
    if (!articolo) return;
    this.materiale.codArt       = articolo.codArt;
    this.materiale.variante     = articolo.varianteArt ?? '';
    this.materiale.desArticolo  = articolo.desArt;
    this.materiale.unitaMisura  = articolo.umMag;
    this.materiale.umSecondaria = articolo.umMag2 ?? '';
  }

  /** US4: valore libero dal selettore → codice non a catalogo. Registra il codice libero e
   *  azzera i dati derivati da una selezione precedente. */
  onCodArtLibero(testo: string) {
    this.materiale.codArt       = testo;
    this.materiale.variante     = '';
    this.materiale.desArticolo  = '';
    this.materiale.unitaMisura  = '';
    this.materiale.umSecondaria = '';
  }

  confirm() {
    if (!this.materiale.codArt?.trim()) {
      this.saveMessage.messageError('Seleziona un articolo prima di salvare.');
      return;
    }
    if (this.materiale.quantita <= 0) {
      this.saveMessage.messageError('La quantità deve essere maggiore di zero.');
      return;
    }
    this.loading = true;
    const op = this.isNew
      ? this.venditaService.addMaterialeAsync(this.materiale)
      : this.venditaService.updateMaterialeAsync(this.materiale);

    op.then((saved) => {
        this.saveMessage.messageInfo(
          this.isNew ? 'Materiale aggiunto.' : 'Materiale aggiornato.'
        );
        this.modalCtrl.dismiss(saved, 'confirm');
      })
      .catch(() => this.saveMessage.messageError('Errore nel salvataggio del materiale.'))
      .finally(() => (this.loading = false));
  }

  cancel = () => this.modalCtrl.dismiss(null, 'cancel');
}
